import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/firebase.js";
import logo from "../../assets/logo.svg";
import styles from "./Admin.module.css";

export default function AdminLayout() {
  const navigate = useNavigate();

  const logout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Link to="/home" className={styles.brand}>
          <img src={logo} alt="Ardean Languages" className={styles.logo} />
          <span>Admin</span>
        </Link>
        <nav className={styles.nav}>
          <NavLink
            to="/home"
            className={({ isActive }) =>
              isActive ? styles.navActive : styles.navLink
            }
            end
          >
            Home
          </NavLink>
          <NavLink
            to="/admin/teachers"
            className={({ isActive }) =>
              isActive ? styles.navActive : styles.navLink
            }
          >
            Tutors
          </NavLink>
          <NavLink
            to="/admin/comments"
            className={({ isActive }) =>
              isActive ? styles.navActive : styles.navLink
            }
          >
            Comments
          </NavLink>
          <NavLink
            to="/admin/deletes"
            className={({ isActive }) =>
              isActive ? styles.navActive : styles.navLink
            }
          >
            Deletes
          </NavLink>
          <button type="button" className={styles.logout} onClick={logout}>
            Log out
          </button>
        </nav>
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
